import { Mutation, RestApiKey } from 'graphql/generated/graphqlTypes';
import { generateMockRestApiKey } from 'mocks/graphqlMocks/restApiKey';

export function mockedAddRestAPIKeyData(addRestApiKey: RestApiKey): Pick<Mutation, 'addRestApiKey'> {
  return {
    addRestApiKey
  };
}

export const mockedAddRestAPIKeyDataForMutation = mockedAddRestAPIKeyData(
  generateMockRestApiKey({
    id: 'mockedAddedRestAPIKeyId',
    description: 'mockedAddedRestAPIKeyName'
  })
);
